<template>
  <div>
    <exercise-logic
      :exCollection="$route.meta.model"
      :saveState="saveState"
      @ready="onReady"
      @error="onError"
      @saved="onSaved"
      @savedNext="onSavedNext"
      @loadedEx="onLoadedEx"
      :doc="doc"
      :shared="true"
      :pid="false"
    >
      <template slot-scope="{ saveExercise }">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step
              color="amber"
              :complete="e1 > 1"
              step="1"
              @click="e1 = 1"
              >Choose competitors</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              color="amber"
              :complete="e1 > 2"
              step="2"
              @click="e1 = 2"
              >Position yourselves</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              color="amber"
              :complete="e1 > 3"
              step="3"
              @click="e1 = 3"
              >Landscape</v-stepper-step
            >
            <v-divider></v-divider>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="relative">
                <v-row>
                  <v-col cols="4" class="mb-4">
                    <h2
                      class="headline"
                      v-text="$t(`${$route.meta.content}.step1.title`)"
                    ></h2>
                  </v-col>

                  <v-col cols="8" class="">
                    <p
                      v-for="(item, index) in $t(
                        `${$route.meta.content}.step1.description`
                      )"
                      :key="index"
                      v-text="item"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="doc">
                  <v-col cols="3">
                    <v-card
                      height="100%"
                      light
                      :color="$t(`${$route.meta.content}.color-1`)"
                    >
                      <v-card-text>
                        <quadrant-items
                          v-model="doc.matrix.q1"
                          name="matrix.q1"
                          :title="$t(`${$route.meta.content}.col1`)"
                          subtitle=""
                          :isAdmin="isAdmin"
                          @change="doAutoSave"
                        ></quadrant-items>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card
                      height="100%"
                      light
                      :color="$t(`${$route.meta.content}.color-2`)"
                    >
                      <v-card-text>
                        <quadrant-items
                          v-model="doc.matrix.q2"
                          name="matrix.q2"
                          :title="$t(`${$route.meta.content}.col2`)"
                          subtitle=""
                          :isAdmin="isAdmin"
                          @change="doAutoSave"
                        ></quadrant-items> </v-card-text
                    ></v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card
                      height="100%"
                      light
                      :color="$t(`${$route.meta.content}.color-3`)"
                    >
                      <v-card-text>
                        <quadrant-items
                          v-model="doc.matrix.q3"
                          name="matrix.q3"
                          :title="$t(`${$route.meta.content}.col3`)"
                          subtitle=""
                          :isAdmin="isAdmin"
                          @change="doAutoSave"
                        ></quadrant-items> </v-card-text
                    ></v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card
                      height="100%"
                      light
                      :color="$t(`${$route.meta.content}.color-4`)"
                    >
                      <v-card-text>
                        <quadrant-items
                          v-model="doc.matrix.q4"
                          name="matrix.q4"
                          :title="$t(`${$route.meta.content}.col4`)"
                          subtitle=""
                          :isAdmin="isAdmin"
                          @change="doAutoSave"
                        ></quadrant-items> </v-card-text
                    ></v-card>
                  </v-col>
                </v-row>
              </div>

              <bottom-navigation
                :save="true"
                :next="true"
                :prev="false"
                :gridView="false"
                :gridToggle="false"
                @save="saveExercise(true)"
                @next="nextStep"
                @prev="prevStep"
              >
              </bottom-navigation>
            </v-stepper-content>
            <v-stepper-content step="2">
              <div class="relative">
                <v-row>
                  <v-col cols="4" class="mb-4">
                    <h2
                      class="headline"
                      v-text="$t(`${$route.meta.content}.step2.title`)"
                    ></h2>
                  </v-col>

                  <v-col cols="8" class="">
                    <p
                      v-for="(item, index) in $t(
                        `${$route.meta.content}.step2.description`
                      )"
                      :key="index"
                      v-text="item"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="doc">
                  <v-col cols="6">
                    <v-card
                      height="100%"
                      light
                      :color="$t(`${$route.meta.content}.color-5`)"
                    >
                      <v-card-text>
                        <quadrant-items
                          v-model="doc.matrix.q5"
                          name="matrix.q5"
                          :title="$t(`${$route.meta.content}.col5`)"
                          :isAdmin="isAdmin"
                          @change="doAutoSave"
                        ></quadrant-items>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <bottom-navigation
                :save="true"
                :next="true"
                :prev="true"
                :gridView="false"
                :gridToggle="false"
                @save="saveExercise(true)"
                @next="nextStep"
                @prev="prevStep"
              >
              </bottom-navigation>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="dropdownCategories"
                        v-model="filters"
                        item-text="title"
                        item-value="value"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col :cols="col1">
                  <div v-if="!editMode">
                    <template v-for="(item, key, index) in doc.matrix">
                      <v-list
                        dense
                        :key="`${key}-${index}`"
                        v-if="filterList(key)"
                      >
                        <v-list-item>
                          <v-list-item-title>
                            {{ $t(`${$route.meta.content}.col${index + 1}`) }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <template v-for="row in item">
                          <v-list-item
                            :key="`${key}-${row.id}`"
                            @click="editItem(row, key)"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-axis-arrow</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                >{{ row.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                <span class="small" v-if="'scale' in row">
                                  {{ row.scale.axis1 }} /
                                  {{ row.scale.axis2 }}
                                </span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <v-divider></v-divider>
                      </v-list>
                    </template>
                  </div>
                  <CompetitionForm
                    v-if="editMode && activeModel"
                    v-model="activeModel"
                    @update="updateForm($event)"
                    @close="closeItem"
                    :axis1="axis1"
                    :axis2="axis2"
                  />
                </v-col>
                <v-col :cols="col2">
                  <CompetitionMatrix
                    :matrix="filteredMatrix"
                    :axis1="axis1"
                    :axis2="axis2"
                    :filter="filters"
                    :editMode="editMode"
                    @editItemMatrix="editItemMatrix"
                    :min="-10"
                    :max="-10"
                    :key="e1"
                  />
                </v-col>
              </v-row>
              <bottom-navigation
                :save="true"
                :next="false"
                :prev="true"
                :gridView="false"
                :gridToggle="false"
                @save="saveExercise(true)"
                @prev="prevStep"
                @next="nextStep"
              >
              </bottom-navigation>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </template>
    </exercise-logic>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t(`${$route.meta.content}.saved.title`)"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title
          class="headline"
          v-text="$t(`${$route.meta.content}.saved.title`)"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";

import { QuadrantItems } from "@/views/user/exercises/quadrant";
import {
  CompetitionForm,
  CompetitionMatrix,
} from "@/views/user/exercises/competition";

export default {
  name: "UserQuadrants",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "add",
      allItems: null,
      listName: "",
      filters: null,
      results: {
        items: [],
      },
      dropdownCategories: [
        { value: null, title: "All" },
        { value: "q1", title: this.$t(`${this.$route.meta.content}.col1`) },
        { value: "q2", title: this.$t(`${this.$route.meta.content}.col2`) },
        { value: "q3", title: this.$t(`${this.$route.meta.content}.col3`) },
        { value: "q4", title: this.$t(`${this.$route.meta.content}.col4`) },
        { value: "q5", title: this.$t(`${this.$route.meta.content}.col5`) },
      ],
      doc: {
        matrix: {
          q1: [],
          q2: [],
          q3: [],
          q4: [],
          q5: [],
        },
      },
      axis1: {
        from: "Modern",
        to: "Traditional",
      },
      axis2: {
        from: "Aspirational",
        to: "Accessible",
      },
      min: -10,
      max: 10,
      list: [],
      listLength: 1,
      debug: false,
      activeModel: null,
      activeList: null,
      editMode: false,
      saveState: false,
      autoSave: true,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    QuadrantItems,
    CompetitionForm,
    CompetitionMatrix,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    isAdmin() {
      // return this.currentUser.uid === "4jd41CisaJZmDYMwCGMRhFclhXY2";
      return true;
    },
    col1() {
      return this.editMode ? "6" : "2";
    },
    col2() {
      return this.editMode ? "6" : "10";
    },
    filteredMatrix() {
      if (this.filters) {
        // console.log(this.doc.matrix[this.filters]);
        return this.doc.matrix[this.filters];
      } else {
        return this.doc.matrix;
      }
    },
  },
  mounted() {},

  watch: {
    matrix: {
      deep: true,
      handler() {
        this.doAutoSave();
      },
    },
  },

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedEx(items) {
      if (items) {
        this.mergeArrays(items.doc);
      }
    },
    onSavedNext() {
      // this.nextStep();
      console.log("autosaved");
      this.saveState = false;
    },
    addIdea() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    updateForm($event) {
      console.log("update", $event);
      const item = this.activeList.find((x) => x.id === $event.id);
      if (!item) return;
      const index = this.activeList.indexOf(item);
      this.$set(this.activeList, index, $event);
    },
    clone(obj) {
      Object.assign({}, obj);
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      Object.entries(arr).forEach(([outerKey, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          this.doc[outerKey][key] = value;
        });
      });
    },
    editItem(node, list) {
      const base = {
        scale: {
          axis1: 0,
          axis2: 0,
        },
        description: "",
        title: "",
      };
      this.activeModel = {
        ...base,
        ...node,
      };
      this.activeList = this.doc.matrix[list];
      this.editMode = true;
    },
    editItemMatrix(node) {
      const base = {
        scale: {
          axis1: 0,
          axis2: 0,
        },
        description: "",
        title: "",
      };
      this.activeModel = {
        ...base,
        ...node,
      };
      this.activeList = this.doc.matrix[node.list];
      this.editMode = true;
    },
    closeItem() {
      this.activeModel = null;
      this.editMode = false;
    },
    filterList(key) {
      if (!this.filters) {
        return true;
      }
      if (key === this.filters) {
        return true;
      } else {
        return false;
      }
    },
    // addNote() {
    //   this.dialogMode = "add";
    //   this.dialog = true;
    // },
    // editNote($event) {
    //   console.log("edit note", $event);
    //   this.dialogMode = "edit";
    //   this.cardId = $event;
    //   this.dialog = true;
    // },
    // showNote($event) {
    //   console.log("show note", $event);
    //   this.dialogMode = "show";
    //   this.cardId = $event;
    //   this.dialog = true;
    // },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    doAutoSave() {
      if (this.autoSave) {
        console.log("doing autosave");
        this.saveState = true;
      }
    },
  },
};
</script>

<style lang="scss"></style>
